import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CreateTaskPage } from "@client/components/doc-generation/create-task-page";

const createTaskSearchSchema = z.object({
  projectId: z.string().optional(),
});

export const Route = createFileRoute("/_app/doc-generation/create")({
  validateSearch: createTaskSearchSchema,
  component: CreateTask,
});

function CreateTask() {
  const { projectId } = Route.useSearch();
  return <CreateTaskPage projectId={projectId} />;
}
